<template>
    <div class="contract-file-uploader-component" ref="root">
        <div
            :class="{ uploader: true, 'drag-over': isDragging }"
            @drop="handleDrop"
            @dragover="handleDragOver"
            @dragleave="handleDropLeave"
        >
            <i class="fas fa-cloud-upload-alt"></i>
            契約書をドラッグ&ドロップ、またはファイルをアップロードしてください。
            <div class="button-wrapper">
                <input
                    @change="handleButton"
                    type="file"
                    accept=".pdf"
                    multiple
                />
                <div class="btn btn-primary">ファイル選択</div>
            </div>
        </div>
        <small class="text-info">
            ※同時アップロードの上限は{{ maxFiles }}件、1ファイルのサイズ上限は{{
                maxSize
            }}MBになります<br />
            ※アップロードできるファイルはPDFのみになります
        </small>
    </div>
    <div v-show="files.length > 0" class="file-list">
        <div v-for="(file, index) in files">
            {{ file.name }}
            <i @click="handleRemove(index)" class="fas fa-times"></i>
        </div>
    </div>
    <ul v-show="errors.length > 0" class="errors">
        <li v-for="error in errors">{{ error }}</li>
    </ul>
</template>

<script>
import { ref, onMounted, watch } from "vue";

export default {
    props: {
        maxFiles: {
            type: Number,
            default: 5,
        },
        maxSize: {
            // MB
            type: Number,
            default: 1,
        },
    },

    setup(props) {
        const errors = ref([]);
        const files = ref([]);
        const isDragging = ref(false);
        const maxSizeByte = props.maxSize * 1024 * 1024; // MB -> Byte
        let form;
        let submitButton;

        const handleButton = (e) => {
            errors.value = [];
            addFiles(e.target.files);
        };

        const handleDrop = (e) => {
            e.preventDefault(); // ブラウザのデフォルト動作をキャンセル
            isDragging.value = false;
            errors.value = [];
            addFiles(e.dataTransfer.files);
        };

        const handleDragOver = (e) => {
            e.preventDefault(); // ブラウザのデフォルト動作をキャンセル
            isDragging.value = true;
        };

        const handleDropLeave = () => {
            isDragging.value = false;
        };

        const handleRemove = (index) => {
            files.value.splice(index, 1);
        };

        const addFiles = (newFiles) => {
            newFiles.forEach((file) => {
                if (validateFile(file)) {
                    files.value.push(file);
                }
            });
        };

        const addError = (message) => {
            if (!errors.value.includes(message)) {
                errors.value.push(message);
            }
        };

        const validateFile = (file) => {
            if (file.type !== "application/pdf") {
                addError(
                    `${file.name}はPDFファイルではないためアップロードできません`
                );
            }
            if (file.size > maxSizeByte) {
                addError(
                    `${file.name}はファイルサイズ上限（${props.maxSize}MB）を超えているためアップロードできません`
                );
            }
            return errors.value.length === 0;
        };

        const submit = () => {
            submitButton.disabled = true;
            const dataTransfer = new DataTransfer();
            files.value.forEach((file) => {
                dataTransfer.items.add(file);
            });
            document.getElementById("fileInput").files = dataTransfer.files;
            form.submit();
        };

        onMounted(() => {
            form = document.getElementById("form");
            submitButton = document.getElementById("submitButton");
            submitButton.addEventListener("click", submit);
        });

        watch(
            () => files.value,
            (newFiles) => {
                if (newFiles.length > props.maxFiles) {
                    addError(
                        `同時にアップロードできるファイルは${props.maxFiles}件までになります`
                    );
                    files.value = newFiles.slice(0, props.maxFiles);
                }
                submitButton.disabled = newFiles.length === 0;
            },
            { deep: true }
        );

        return {
            files,
            errors,
            isDragging,
            handleButton,
            handleDrop,
            handleDragOver,
            handleDropLeave,
            handleRemove,
        };
    },
};
</script>
